<template>
  <div>
    <v-dialog
      @keydown.esc="closeDialog"
      max-width="1400px"
      persistent
      :retain-focus="false"
      v-model="$store.getters.bookInfoDialog"
    >
      <v-card
        style="height: 90vh; overflow-y: auto"
        class="d-flex flex-column subtle-white"
      >
        <v-card-title class="headline white--text app-gradient">
          <span class="text-truncate" style="max-width: 110ch">{{
            book.title
          }}</span>
          <v-spacer />
          <v-btn color="gray" icon @click="closeDialog">
            <v-icon large>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row justify="center">
            <v-col cols="5" class="ma-0 pa-0 mt-3">
              <v-tabs
                v-model="tab"
                centered
                height="45px"
                icons-and-text
                light
                background-color="#FAFAFA"
              >
                <v-tabs-slider />
                <v-tab class="subtle-white">Εξώφυλλο</v-tab>
                <v-tab class="subtle-white">Οπισθόφυλλο</v-tab>
              </v-tabs>

              <v-tabs-items v-model="tab" class="subtle-white">
                <v-tab-item>
                  <v-row class="pt-10" justify="center">
                    <v-col cols="11">
                      <v-img
                        :src="cover"
                        class="white--text"
                        max-width="500px"
                        max-height="650px"
                        contain
                      />
                    </v-col>
                  </v-row>
                </v-tab-item>

                <v-tab-item>
                  <v-row class="pt-10" justify="center">
                    <v-col cols="11">
                      <v-img
                        :src="backCover"
                        class="white--text"
                        max-width="500px"
                        max-height="650px"
                        contain
                      />
                    </v-col>
                  </v-row>
                </v-tab-item>
              </v-tabs-items>
            </v-col>

            <v-col cols="7" class="ma-0 pa-0 mt-3 d-flex flex-column">
              <h2 style="color: #11455b" class="mt-4">Στοιχεία Συγγράμματος</h2>
              <v-divider class="mt-2" />
              <v-card class="mt-4">
                <v-row justify="center">
                  <v-col cols="8" class="px-1 mx-0 subtle-white">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title> Τίτλος </v-list-item-title>
                        <v-list-item-subtitle
                          >{{ book.title }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item
                      v-if="book.subtitle && String(book.subtitle).trim()"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          Υπότιτλος
                          <v-tooltip
                            v-if="book.subtitle"
                            color="primary"
                            bottom
                            open-on-click
                            content-class="authors-tooltip-content"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                class="ml-2"
                                color="primaryLighter"
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-magnify-expand
                              </v-icon>
                            </template>

                            <div class="authors-tip pa-2">
                              {{ book.subtitle }}
                            </div>
                          </v-tooltip>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <span class="subtitle-preview text-truncate">
                            {{ book.subtitle }}
                          </span>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          Κωδικός Βιβλίου στον Εύδοξο
                        </v-list-item-title>
                        <v-list-item-subtitle>{{
                          book.id
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          Συγγραφείς
                          <v-icon
                            @click="openAuthorsDialog"
                            color="primaryLighter"
                          >
                            mdi-magnify-expand
                          </v-icon>
                        </v-list-item-title>
                        <v-list-item-subtitle
                          >{{ book.authors }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          Διαθέτης (Εκδότης)</v-list-item-title
                        >
                        <v-list-item-subtitle
                          >{{ book.publisherName }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title> Εκδόσεις</v-list-item-title>
                        <v-list-item-subtitle
                          >{{ book.editorialHouse }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          Λέξεις Κλειδιά
                          <v-icon
                            @click="openKeywordsDialog"
                            color="primaryLighter"
                          >
                            mdi-magnify-expand
                          </v-icon>
                        </v-list-item-title>
                        <v-list-item-subtitle
                          >{{ keywords }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item v-if="book.type === 'ProfessorNotes'">
                      <v-list-item-content>
                        <v-list-item-title> Άδεια </v-list-item-title>
                        <v-list-item-subtitle>
                          <a
                            :href="'https://creativecommons.org/licenses/by-nc-nd/3.0/deed.el'"
                            target="_blank"
                            rel="noopener noreferrer"
                            >{{ book.licenseId }}</a
                          >
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>
                          <v-chip
                            style="max-width: 200px"
                            outlined
                            v-if="book.pathToTOC"
                            color="primaryLighter"
                            ><h5>Πίνακας Περιεχομένων</h5>
                            <v-icon
                              @click="openBookFilePdf(book.pathToTOC)"
                              color="primaryLighter"
                            >
                              visibility
                            </v-icon>
                          </v-chip>
                          <v-chip
                            style="max-width: 200px"
                            outlined
                            v-if="book.pathToChapter"
                            color="primaryLighter"
                            ><h5>Ενδεικτικό Απόσπασμα</h5>
                            <v-icon
                              @click="openBookFilePdf(book.pathToChapter)"
                              color="primaryLighter"
                            >
                              visibility
                            </v-icon>
                          </v-chip>
                          <v-chip
                            style="max-width: 200px"
                            outlined
                            v-if="
                              book.pathToFile && book.type === 'ProfessorNotes'
                            "
                            color="primaryLighter"
                            ><h5>Αρχείο</h5>
                            <v-icon
                              @click="openBookFilePdfFromBackEnd(book.id)"
                              color="primaryLighter"
                            >
                              mdi-cloud-download
                            </v-icon>
                          </v-chip>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>

                  <v-col cols="4" class="px-1 mx-0 subtle-white">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title> ISBN</v-list-item-title>
                        <v-list-item-subtitle>{{
                          book.isbn
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title> Τύπος</v-list-item-title>
                        <v-list-item-subtitle
                          style="
                            white-space: normal;
                            overflow: visible;
                            text-overflow: unset;
                            overflow-wrap: anywhere;
                            word-break: break-word;
                            -webkit-line-clamp: unset;
                          "
                          >{{ returnBookType(book.type) }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title> Αριθμός Έκδοσης</v-list-item-title>
                        <v-list-item-subtitle
                          >{{ book.editionNumber }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          Έτος Τρέχουσας Έκδοσης
                        </v-list-item-title>
                        <v-list-item-subtitle
                          >{{ book.publicationYear }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title> Δέσιμο</v-list-item-title>
                        <v-list-item-subtitle
                          >{{ returnBookBinding(book.binding) }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title> Διαστάσεις</v-list-item-title>
                        <v-list-item-subtitle
                          >{{ book.dimensions }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title> Αριθμός Σελίδων</v-list-item-title>
                        <v-list-item-subtitle>{{
                          book.pages
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          Ιστοσελίδα Βιβλίου</v-list-item-title
                        >
                        <v-list-item-subtitle>
                          <span v-if="book.linkToPublisher == null">
                            Χωρίς
                          </span>
                          <span
                            v-else
                            style="
                              color: darkslategrey;
                              cursor: pointer;
                              text-decoration: underline;
                            "
                            @click="confirmWindowOpen(book.linkToPublisher)"
                            >Εδώ</span
                          >
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Keywords dialog - placed as sibling to prevent nested overlay issues -->
    <v-dialog v-model="authorsDialog" max-width="700px" :retain-focus="false">
      <v-card class="d-flex flex-column">
        <v-data-table
          :headers="[{ text: '', value: 'author', align: 'center' }]"
          :items="authorsItems"
          hide-default-header
          :search="authorsSearch"
          dense
        >
          <template v-slot:top>
            <v-text-field
              v-model="authorsSearch"
              label="Search"
              class="mx-2"
            ></v-text-field>
          </template>

          <template v-slot:item.author="{ item }">
            {{ item.author }}
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

    <!-- Keywords dialog - placed as sibling to prevent nested overlay issues -->
    <v-dialog v-model="keywordsDialog" max-width="700px" :retain-focus="false">
      <v-card class="d-flex flex-column">
        <v-data-table
          :headers="[{ text: '', value: 'keyword', align: 'center' }]"
          :items="(book.keywords || []).map((k) => ({ keyword: k }))"
          hide-default-header
          :search="search"
          dense
        >
          <template v-slot:top>
            <v-text-field
              v-model="search"
              label="Search"
              class="mx-2"
            ></v-text-field>
          </template>

          <template v-slot:item.keyword="{ item }">
            {{ item.keyword }}
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

    <CustomWindowConfirm ref="confirmDialog" />
  </div>
</template>

<script>
import CustomWindowConfirm from "./CustomWindowConfirm";
import requests from "../requests";
import utils from "../utilities";

export default {
  name: "BookInfoDialog",
  components: { CustomWindowConfirm },
  props: {
    book: Object,
  },
  data: () => ({
    typeSelector: [
      { label: "Σύγγραμμα", value: "Published" },
      { label: "Ηλεκτρονικό Βιβλίο", value: "eBook" },
      {
        label: "Δωρεάν Ηλεκτρονικό Βοήθημα / Σημειώσεις",
        value: "ProfessorNotes",
      },
    ],
    tab: 0,
    defaultCover: require("../assets/blank.png"),
    cover: null,
    backCover: null,
    search: "",
    subjects: "",
    keywords: "",
    authorsSearch: "",
    authorsDialog: false,
    keywordsDialog: false,
  }),
  computed: {
    authorsItems() {
      if (Array.isArray(this.book.authors)) {
        return this.book.authors
          .map((author) => (author == null ? "" : String(author).trim()))
          .filter((author) => author.length > 0)
          .map((author) => ({ author }));
      }

      if (typeof this.book.authors === "string") {
        return this.book.authors
          .split(",")
          .map((author) => author.trim())
          .filter((author) => author.length > 0)
          .map((author) => ({ author }));
      }

      return [];
    },
  },
  methods: {
    closeDialog() {
      this.$store.commit("setBookInfoDialog", false);
    },

    async confirmWindowOpen(url) {
      const ok = await this.$refs.confirmDialog.show({
        message:
          "Θα ανακατευθυνθείτε προς τον ορισμένο από τον εκδότη ιστότοπο, " +
          url +
          " .Για να συνεχίσετε πατήστε επιβεβαίωση",
      });
      if (ok) {
        window.open(url, "_blank", "noopener,noreferrer");
      }
    },

    openBookFilePdfFromBackEnd(bookId) {
      document.activeElement.blur();
      this.$store.commit("setLoadingModal", true);
      requests.postForFiles(
        "rest/courses-books/book/eudoxus/get-book-pdf",
        bookId,
        this.getResultPdfFileCallBack
      );
    },

    getResultPdfFileCallBack(response) {
      this.$store.commit("setLoadingModal", false);
      utils.downLoadPDFNewTab(response);
    },

    openAuthorsDialog() {
      this.authorsDialog = true;
      document.activeElement.blur();
    },

    openKeywordsDialog() {
      this.keywordsDialog = true;
      document.activeElement.blur();
    },

    returnBookType(type) {
      if (type === "Published") {
        return "Σύγγραμμα";
      } else if (type === "eBook") {
        return "Ηλεκτρονικό Βιβλίο";
      } else if (type === "ProfessorNotes") {
        return "Δωρεάν Ηλεκτρονικό Βοήθημα / Σημειώσεις";
      } else if (type === "UniversityPress") {
        return "Πανεπιστημιακή Έκδοση";
      } else if (type === "Free") {
        return "Δωρεάν Βιβλίο";
      } else {
        return "--";
      }
    },

    returnBookBinding(binding) {
      console.log(binding);
      if (binding === null || binding === undefined) {
        return "";
      }

      if (binding.toLowerCase() === "soft") {
        return "μαλακό";
      } else if (binding.toLowerCase() === "hard") {
        return "σκληρό";
      } else if (binding.toLowerCase() === "Leather".toLowerCase()) {
        return "δερματόδετο";
      } else {
        return "χωρίς";
      }
    },

    openBookFilePdf(url) {
      document.activeElement.blur();
      window.open(this.reformatBookPath(url), "_blank");
    },

    reformatBookPath(path) {
      if (
        path !== undefined &&
        path !== null &&
        path.substring(0, 4) !== "http"
      ) {
        return "https://static.eudoxus.gr/books/" + path;
      } else {
        return path;
      }
    },

    async getCover(pathToCover) {
      const url = this.reformatBookPath(pathToCover);
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(url);
        img.onerror = () => resolve(this.defaultCover);
        img.src = url;
      });
    },

    async loadCovers() {
      this.cover = await this.getCover(this.book.pathToCover);
      this.backCover = await this.getCover(this.book.pathToBackcover);
    },
  },

  created() {
    this.loadCovers();

    if (this.book.subjects && this.book.subjects.length > 0) {
      this.subjects = this.book.subjects.join(", ");
    }
    if (this.book.keywords && this.book.keywords.length > 0) {
      this.keywords = this.book.keywords.join(", ");
    }
  },
};
</script>

<style scoped>
.subtitle-preview {
  display: inline-block;
  max-width: 260px;
}

::v-deep .authors-tooltip-content {
  background: transparent !important;
  box-shadow: none !important;
  opacity: 1 !important;
  padding: 0 !important;
}

::v-deep .authors-tip {
  width: 320px;
  max-width: 320px;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  background-color: #3c3c3c;
  color: #fff;
  border-radius: 6px;
}
</style>
